/**
 * Trạng thái của form
 */
export default {
  CreateReport: 0,
  ReCreateReport: 1,
};
